import { Loader, LoaderProps } from '@/components/Loader';
import type { StandaloneComponent } from '@/types/component';

export type ScrollPageControlsLoaderProps = LoaderProps;

export const ScrollPageControlsLoaderComponent: StandaloneComponent<ScrollPageControlsLoaderProps> = (props) => {
  return <Loader {...props} />;
};
